import { Step, StepLabel, Typography } from '@mui/material';
import React from 'react';
import UploadTabSkeleton from '../UploadTabSkeleton';
import { useAppSelector } from '../../../../store/hooks';
import { convertFileFormatToText, getUploadFileTypes, getXMLFileTypes } from '../../../../utils/string';
import CellebriteSheetMetadata from '../../../Metadata/CellebriteSheetMetadata';
import CellebriteXMLMetadata from '../../../Metadata/CellebriteXMLMetadata';
import TabHeader from '../../../TabHeader';
import { UploadFormProvider } from '../UploadFormContext';
import { MoreVert } from '@mui/icons-material';

const CellebriteTab: React.FC = () => {
	const fileFormat = useAppSelector((state) => state.upload.currentFileFormat);
	const userRoles = useAppSelector((state) => state.tab.userRoles);

	const allowedFormats = userRoles.includes('SUPERUSER') ? getUploadFileTypes() : getXMLFileTypes();

	const chooseTab = () => {
		switch (convertFileFormatToText(fileFormat)) {
			case 'CSV':
			case 'XLS':
			case 'XLSX':
				return <CellebriteSheetMetadata />;
			case 'XML':
				return <CellebriteXMLMetadata />;
			case '':
				return (
					<Step disabled>
						<StepLabel icon={<MoreVert />}>
							<Typography>More steps will be enabled after a file is uploaded </Typography>
						</StepLabel>
					</Step>
				);
			default:
				return <Typography>Unhandled file format {`(${fileFormat})`}</Typography>;
		}
	};

	return (
		<UploadFormProvider>
			<TabHeader />
			<UploadTabSkeleton allowedFormats={allowedFormats} testTag="cellebrite-tab-content">
				{React.Children.toArray(chooseTab())}
			</UploadTabSkeleton>
		</UploadFormProvider>
	);
};

export default CellebriteTab;
